import styled from 'styled-components'
import { css, media, truncate, colors, rgba, radiuses, innerBackground } from 'styles'
import Checkbox, { CheckboxCustom } from 'components/Controls/Checkbox/StyledCheckbox'
import Select from 'components/Controls/Select/StyledSelect'

const StyledForm = styled.form`
  .criteria {
    padding-bottom: 1.5rem;
  }
  .row > :nth-child(4n + 1) {
    padding-left: 0;
  }
  .row > :nth-child(4n),
  .row > :last-child {
    padding-right: 0;
  }
  .advanced-filters {
    position: relative;
    ${p =>
      !p.upgraded &&
      css`
        padding: 1rem;
        margin-top: 2rem;
      `};
  }
  .trial-overlay {
    position: absolute;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: ${rgba(innerBackground, 0.5)};
    border-radius: ${radiuses.large};
    margin: -1rem;
    z-index: 2;
    overflow: hidden;
    font-size: 1.8rem;
    font-weight: bold;
    .overlay-header {
      width: 100%;
    }
    p {
      margin-bottom: auto;
    }
    #lock {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 8px;
      width: 23em;
      height: 16em;
      border-radius: 2em;
      box-sizing: border-box;
      background: ${rgba(colors.cta, 0.3)};
      margin: auto 0 3rem;
      .button-cta {
        transition: transform 0.3s;
      }
      &:hover {
        &:before {
          transform: translateY(-2em);
        }
        .button-cta {
          transform: scale(1.1);
        }
      }
    }
    #lock::before {
      content: '';
      box-sizing: border-box;
      position: absolute;
      border: 3.5em solid ${rgba(colors.cta, 0.3)};
      width: 14em;
      height: 9em;
      left: 50%;
      margin-left: -7em;
      top: -8.9em;
      border-top-left-radius: 7em;
      border-top-right-radius: 7em;
      border-bottom: none;
      transition: 0.3s;
    }
    #lock,
    #lock::before,
    #lock a {
      backface-visibility: hidden;
    }
    img {
      z-index: 2;
      max-width: 250px;
      position: absolute;
      opacity: 0.25;
    }
  }

  .criteria-name {
    margin-bottom: 0.8rem;
    font-size: 1.2rem;
    text-transform: uppercase;
    color: ${colors.textSecondary};
    ${truncate('100%')};
  }

  .row {
    display: flex;
    flex-wrap: wrap;
  }
  .submit-criteria {
    display: flex;

    .criteria-controls {
      flex: 1;
      display: flex;
      text-align: center;
      align-items: center;
    }
    &.premium-submit {
      flex: 1;
      display: ${p => (p.upgraded ? 'flex' : 'none')};
    }
  }

  .submit-button {
    width: 100%;
    padding: 1.6rem 0;
    border: 0;
    background-color: ${colors.highlight};
    color: ${colors.mainInverted};
    font-size: 1.4rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  .show-profiles {
    flex: 1;
    padding: 1% 2%;

    .criteria-name {
      margin-bottom: 0.5rem;
    }

    .checklist {
      display: flex;
    }
  }

  ${Checkbox} {
    font-size: 2rem;
    label {
      margin-left: 0.5rem;
      font-size: 1.4rem;
      color: ${colors.textSecondary};
    }

    ${CheckboxCustom} {
      border-color: ${colors.divider};
    }

    ~ ${Checkbox} {
      margin-left: 1rem;
    }
  }

  ${media.mobile`
    .basic-submit {
      order: 2;
    }

    .show-profiles {
      margin-bottom: 1rem;

      .checklist {
        ${Checkbox} {
          font-size: 2.5rem;
          flex: 1;

          label {
            font-size: 1.8rem;
          }
        }
      }
    }

    .trial-overlay {
      p {
        text-align: center;
      }
    }
    .criteria-name {
      font-size: 1.6rem;
    }

    .submit-button {
      font-size: 1.8rem;
    }
    /* Premium submit */
    .submit-criteria:last-child {
      margin: 1rem auto 0;
    }
  `}
`
const StyledCriteria = styled.div`
  width: 25%;
  padding: 1% 2%;
  box-sizing: border-box;
  ${p =>
    p.disabled &&
    css`
      .criteria-name {
        opacity: 0.5;
      }
    `}

  &.criteria-age {
    .criteria-controls {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: ${colors.textSecondary};
      font-size: 1.4rem;
    }

    ${Select} {
      width: 40%;
    }
  }

  ${media.mobile`
    width: 50%;
    padding: 1% 2% 2rem !important; /* regardless of column */

    &.criteria-age {
      .age-separator {
        font-size: 1.8rem;
      }
    }
  `}

  ${media.phone`
    width: 100%;
  `}
`

const StyledFilterGroup = styled.div`
  margin: 2rem 0 1rem;

  .group-name {
    margin-bottom: 2rem;
    font-size: 1.4rem;
    color: ${colors.textMain};
  }

  ${media.mobile`
    .group-name {
      font-size: 1.8rem;
      padding: 0 2%;
    }
  `}
`

export default StyledForm
export { StyledCriteria, StyledFilterGroup }
